import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { KontakReferensiByIDResponse } from "../../../../models/KontakReferensi";

export const allKontakReferensiKey = "all-kontak-referensi-key";

export async function kontakReferensi(
    ID: number
): Promise<KontakReferensiByIDResponse> {
    const res = await ApiClient.get(
        `/ReferenceContactDetail/${ID}`
    );
    return res.data;
}

export const useFetchKontakReferensi = mutationWrapper(kontakReferensi);
